export default {
  'footer.copyright': '© 2025 多肉男子文化推廣協會 版權所有',
  'footer.links.usage': '會員條款',
  'footer.links.privacy': '隱私權條款',
};
